import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Trash2, Mail } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem("ghp-admin-token")}` });

const NewsletterTab = () => {
  const { t, lang } = useLanguage();
  const [subs, setSubs] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/admin/newsletter`, { headers: authHeader() });
      setSubs(data);
    } catch (e) {
      if (e.response?.status === 401) {
        localStorage.removeItem("ghp-admin-token");
        window.location.href = "/admin/login";
      }
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-GB", { day: "numeric", month: "long", year: "numeric" });

  const del = async (id) => {
    if (!window.confirm(t("admin.confirmDelete"))) return;
    try {
      await axios.delete(`${API}/admin/newsletter/${id}`, { headers: authHeader() });
      toast.success(t("admin.deleted"));
      load();
    } catch {
      toast.error(t("forms.error"));
    }
  };

  return (
    <div data-testid="admin-newsletter-tab">
      <p className="overline-mono text-forest">
        {t("admin.subscribers")} — {subs.length}
      </p>
      <div className="mt-6 space-y-3">
        {subs.length === 0 && (
          <p className="border border-dashed border-graphite/20 py-16 text-center text-sm text-graphite-soft">{t("admin.empty")}</p>
        )}
        {subs.map((s) => (
          <div key={s.id} className="flex items-center justify-between gap-4 border border-graphite/10 bg-white px-6 py-4" data-testid={`admin-subscriber-${s.id}`}>
            <div className="flex items-center gap-4">
              <Mail className="h-4 w-4 shrink-0 text-forest" />
              <a href={`mailto:${s.email}`} className="text-sm text-graphite underline-offset-4 hover:underline">{s.email}</a>
              <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-graphite-soft">{s.lang || "fr"}</span>
            </div>
            <div className="flex shrink-0 items-center gap-4">
              <span className="font-mono text-[11px] text-graphite-soft">
                {t("admin.subscribedOn")} {fmtDate(s.created_at)}
              </span>
              <button onClick={() => del(s.id)} aria-label={t("admin.delete")} className="text-graphite/30 transition-colors hover:text-destructive" data-testid={`admin-subscriber-delete-${s.id}`}>
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsletterTab;
